<script lang="ts">
    
    import { fly } from 'svelte/transition';
    import { navigate } from "svelte-navigator";
    import LottiePlayer from "../Components/LottiePlayer.svelte";
    import Slide from "../Components/Slide.svelte";
    import Slider from "../Components/Slider.svelte";
    import { avatars } from "../environment";
    import { avatar } from "../Services/avatar";
    import Audio from '../Components/Audio.svelte';
    import type { Fn } from '../global';
    import { getContext, onMount } from 'svelte';

    const playMainTheme: Fn = getContext('playMainTheme');

    let slider: Slider;
    let activeIndex: number;
    let isFirst = false;
    let isLast = false;
    let wooshSound: Audio;

    // $: if (wooshSound) wooshSound.volume = 0.25;
    $: {
        $avatar = avatars[activeIndex] || null;
        isFirst = activeIndex === 0;
        isLast = activeIndex === avatars.length - 1;
    }

    onMount(playMainTheme);

    function onGo(): void {
        navigate('/trivial');
    }

    function onTransitionstart(): void {
        wooshSound?.play();
    }

</script>

<style lang="scss">

    @use '../variables';

    .title {
        padding: 1rem;
        text-align: center;
        text-transform: uppercase;
        color: #fff;
    }

    .slider {
        flex: 1 1 0;
        position: relative;
        min-height: 0;
        padding: 1rem 0;
        display: flex;
        flex-direction: column;
    }

    .nav-btn {
        $size: 30px;
        position: absolute;
        z-index: 2;
        width: $size;
        height: $size;
        top: calc(50% - #{$size * 0.5});
        padding: 0;
        background-color: transparent;
        border: none;

        &:disabled {
            opacity: 0.4;
        }
    }

    .prev-btn {
        left: 1rem;

        img {
            transform: scaleX(-1);
        }
    }

    .next-btn {
        right: 1rem;
    }

    .pages {
        display: flex;
        justify-content: center;
        gap: 0.5rem;
    }

    .page {
        $size: 10px;
        width: $size;
        height: $size;
        box-sizing: border-box;
        border-radius: 50%;
        background-color: #fff;
        opacity: 0.4;

        &.current {
            opacity: 1;
        }
    }

    .go-btn {
        display: block;
        width: calc(100% - 2rem);
        padding: 0.5rem;
        margin: 1rem;
        background-color: variables.$answer-win-color;
        border-radius: 1000rem;
        box-sizing: border-box;
        border: 3px solid #fff;
        color: #fff;
        font-size: 3rem;
        font-weight: bold;
    }

</style>

<Audio bind:this={wooshSound} src="/sound/woosh.mp3" volume={0.4} />

<div class="view">
    <div class="title" in:fly={{ y: -100 }}>
        Selecciona el tema
    </div>
    <div class="slider" style="--height: 100%;">
        <Slider bind:this={slider} bind:activeIndex on:transitionstart={onTransitionstart}>
            {#each avatars as avatar}
                <Slide index={avatar}>
                    <LottiePlayer src={avatar.lottieSrc} />
                </Slide>
            {/each}
        </Slider>
        <button in:fly={{ x: -100 }} type="button" class="nav-btn prev-btn shadow" disabled={isFirst} on:click={() => slider?.prev()}>
            <img src="/images/nav-btn.svg" alt="<">
        </button>
        <button in:fly={{ x: 100 }} type="button" class="nav-btn next-btn shadow" disabled={isLast} on:click={() => slider?.next()}>
            <img src="/images/nav-btn.svg" alt=">">
        </button>
    </div>
    <div class="pages">
        {#each avatars as avatar, index}
        <div class="page" class:current={activeIndex === index}></div>
        {/each}
    </div>
    <button in:fly={{ y: 100 }} type="button" class="go-btn shadow" on:click={onGo}>GO!</button>
</div>
